import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { HeaderButtonRow } from "../../../partial-templates/header-button-row/header-button-row.stories";
import { DetailHeader } from "../../../partial-templates/detail-header/detail-header.stories";
import { serviceCallContactsTab } from "../../my-service-calls/my-service-calls-detail/tabs-content/tabs-content-contact";
import { serviceReportsTab } from "../../my-service-calls/my-service-calls-detail/tabs-content/tabs-content-reports";
import { addI18nTranslations, renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/My Missions/Detail",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
    argTypes: {
        serviceReportsUrl: {
            control: "select",
            options: [
                "./generated-mock-data/service-reports.json",
                "./generated-mock-data/service-reports-multiple.json",
                "./generated-mock-data/service-reports-empty.json",
            ],
            description: "URL to fetch the service reports",
        },
    },
    args: {
        serviceReportsUrl: "./generated-mock-data/service-reports.json",
    },
};

const namespace = "serviceReports";
const translations = {
    title: "Serviceberichte",
    "item.equipment": "Maschine & Machinennummer",
    "item.date": "Berichterstellung",
    "item.date-format": "DD.MM.YYYY",
    "item.download": "Bericht öffnen (PDF)",
    "item.technician": "Techniker Name",
    noReports: "Keine Serviceberichte vorhanden",
};

addI18nTranslations({
    namespace,
    language: "de-DE",
    translations,
});

const Template = ({ serviceReportsUrl }: { serviceReportsUrl: string }) => {
    return html`
        <div class="ux-t-container" data-machine-id="1">
            <div class="ux-u-mt-l">
                ${HeaderButtonRow({
                    buttons: "",
                })}
                ${DetailHeader({
                    image: false,
                    headline:
                        "Wartung und Reparatur <ux-w-status type='MISSION_COMPLETED'>Abgeschlossen</ux-w-status>",
                    subline:
                        "<strong>Maschinenalias</strong> TruMaschine 2030 – TWDEDEMO009",
                    keyValuePairs: [
                        {
                            title: "Einsatzdatum",
                            value:
                                "<ux-date-time utc='2020-05-20 17:32:33' format='DD.MM.YYYY HH:mm'/>",
                        },
                        {
                            title: "Einsatznummer",
                            value: "6144876",
                        },
                        {
                            title: "Fallnummer",
                            value:
                                "<a class='ux-text-link ux-text-link--bold ux-text-link--green' href='#'>8460380 <ux-icon name='arrow-right'></ux-icon></a>",
                        },
                        {
                            title: "Techniker-Name",
                            value: "Max Mustermann",
                        },
                        {
                            title: "Erstellt",
                            value:
                                "<ux-date-time utc='2020-05-18 16:01:23' format='DD.MM.YYYY HH:mm'/>",
                        },
                    ],
                })}
                <div class="ux-u-mt-l">
                    <ux-tab-container fix-to-top scroll-when-activated>
                        <ux-tab
                            name="Servicebericht (legacy)"
                            tab-id="0"
                            class="ux-u-mt-xxs ux-tab-service-reports"
                        >
                            <div class="ux-info-box">
                                ${serviceReportsTab()}
                            </div>
                        </ux-tab>
                        <ux-tab
                            name="Hinterlegter Kontakt"
                            tab-id="1"
                            class="ux-u-mt-xxs ux-tab-contact"
                        >
                            <div class="ux-info-box">
                                ${serviceCallContactsTab()}
                            </div>
                        </ux-tab>
                        <ux-iws-lazy-tab
                            name="Servicebericht"
                            tab-id="2"
                            class="ux-u-mt-xxs ux-tab-service-reports"
                        >
                            <div>
                                <div class="ux-info-box">
                                    <ux-iws-service-reports
                                        src="${serviceReportsUrl}"
                                        language="de-DE"
                                        lazy-load
                                    ></ux-iws-service-reports>
                                </div>
                            </div>
                        </ux-iws-lazy-tab>
                    </ux-tab-container>
                </div>
            </div>
        </div>
    `;
};

export const Default = (args) => renderPageTemplate(() => Template(args));
Default.translations = translations;
Default.namespace = namespace;
